<app-ark-container
  [future]="dataObservable"
  [titleTemplate]="title"
  [loadingTemplate]="loading"
  [successTemplate]="success"
  [failureTemplate]="failure"
  [errorTemplate]="error"
  (onSuccess)="onPreviewDataForSellsideUsersResolved($event[0])"
  (onFailure)="onFailure($event[0])"
>
</app-ark-container>

<ng-template #title>
  <div></div>
</ng-template>
<ng-template #loading>
  <ul nz-menu style="border: none">
    <li
      *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
      style="padding: 0px 25px 0px 15px"
    >
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </li>
  </ul>
</ng-template>
<ng-template #failure>
  <div class="error-container">
    <div class="error-msg">
      <va-icon name="exclamation-triangle" class="info-icon"></va-icon>
      <span class="error-text">{{ errMsg }}</span>
    </div>
  </div>
</ng-template>
<ng-template #error>
  <div class="error-container">
    <div class="error-msg">
      <va-icon name="exclamation-triangle" class="info-icon"></va-icon>
      <span class="error-text">{{ errMsg }}</span>
    </div>
  </div>
</ng-template>
<ng-template #success>
  <div class="error-container" *ngIf="hasError">
    <div class="error-msg">
      <va-icon name="exclamation-triangle" class="info-icon"></va-icon>
      <span class="error-text">{{ errMsg }}</span>
    </div>
  </div>
  <div
    id="earning-preview-content-container"
    *ngIf="isEarningPreviewData && !hasError"
  >
    <div id="preview-header" nz-row>
      <div class="company-details" nz-col nzSpan="8">
        <div
          class="company-name"
          [textContent]="companyName"
          [title]="companyName"
        ></div>
        <div class="analyst-name" style="margin-top: 12px">
          Analyst: <span [textContent]="analystName"></span>
        </div>
        <div class="last-update">
          Last Update:
          <span [textContent]="lastModelDate"></span>
        </div>
      </div>

      <div
        class="email-details"
        *ngIf="showEmailText"
        nz-col
        nzSpan="9"
        nzOffset="5"
      >
        <div class="email-id-holder">
          <!-- <nz-select
    [nzMaxTagCount]="3"
    nzMode="tags"
    nzPlaceHolder="Please select"
    [(ngModel)]="listOfEmails"
    nzSize="small"
  >
    <nz-option
      *ngFor="let item of listOfEmails"
      [nzLabel]="item"
      [nzValue]="item"
    ></nz-option>
  </nz-select> -->

          <nz-tag
            *ngFor="let email of listOfEmails; let i = index"
            nzMode="closeable"
            (nzAfterClose)="handleClose(email)"
          >
            {{ sliceTagName(email) }}
          </nz-tag>
          <nz-tag
            *ngIf="!emailInputVisible"
            class="editable-tag"
            nzNoAnimation
            (click)="showInput()"
            >Enter email address</nz-tag
          >
          <input
            #inputElement
            nz-input
            nzSize="small"
            type="text"
            *ngIf="emailInputVisible"
            [(ngModel)]="inputEmail"
            style="width: 78px; font-size: 12px"
            (blur)="handleInputConfirm()"
            (keydown.enter)="handleInputConfirm()"
          />
        </div>
        <div
          class="warning-icon-holder"
          *ngIf="!isValidEmail"
          [title]="emailErrMsg"
        >
          <va-icon
            name="exclamation-triangle"
            class="fa-sm warning-icon"
          ></va-icon>
        </div>
      </div>
      <div
        class="btn-holder"
        nz-col
        [nzSpan]="headerButtonSpan"
        [nzOffset]="btnOffset"
      >
        <div *ngIf="showSendButton">
          <button nz-button class="send-btn btn" (click)="onSend()">
            <va-icon
              [name]="faEnvelope"
              isFontAwesome="true"
              class="fa-sm send-icon"
            ></va-icon
            >Send
          </button>
        </div>
        <!--<div *ngIf="showShare">
          <button
            nz-button
            nzType="default"
            (click)="onShareClicked()"
            class="send-btn btn"
          >
            <va-icon name="faPaperPlane" class="fa-sm send-icon"></va-icon
            >Share
          </button>
        </div>-->
      </div>
    </div>
    <div id="earnings-table-holder" *ngIf="earningsPreviewDataReady">
      <table id="earnings-table">
        <thead>
          <tr class="earnings-table-outer-header">
            <td class="keyValues">
              <span class="starredHeader"
                >All numbers in {{ currencyValue }} unless stated
                otherwise.</span
              >
            </td>
            <td id="first-period" colspan="3">
              <div class="earnings-preview-dropdown-holder">
                <nz-select
                  class="QA"
                  id="first-period-qa"
                  nzSize="small"
                  [(ngModel)]="firstPeriodQA"
                  (ngModelChange)="estimatedPeriodChange($event, '1')"
                  nzDropdownClassName="period-dropdown"
                  style="width: auto"
                >
                  <nz-option
                    nzCustomContent
                    *ngFor="let qa of earningPreviewQuarters"
                    [nzLabel]="qa.name"
                    [nzValue]="qa"
                  >
                    <span class="opt-style" [innerHtml]="qa.name"></span>
                  </nz-option>
                </nz-select>
                <nz-select
                  class="year"
                  id="first-period-year"
                  nzSize="small"
                  [(ngModel)]="firstPeriodYear"
                  (ngModelChange)="estimatedPeriodChange($event, '1')"
                  style="width: auto"
                >
                  <nz-option
                    nzCustomContent
                    *ngFor="let period of periodDropdown"
                    [nzLabel]="period"
                    [nzValue]="period"
                  >
                    <span class="opt-style" [innerHtml]="period"></span>
                  </nz-option>
                </nz-select>
                <span *ngIf="makeCopy"
                  >{{ firstPeriodQA.value }}-{{ firstPeriodYear }}</span
                >
              </div>
            </td>
            <td id="second-period" colspan="3">
              <div class="earnings-preview-dropdown-holder">
                <nz-select
                  class="QA"
                  id="second-period-qa"
                  nzSize="small"
                  [(ngModel)]="secondPeriodQA"
                  (ngModelChange)="estimatedPeriodChange($event, '2')"
                  nzDropdownClassName="period-dropdown"
                  style="width: auto"
                >
                  <nz-option
                    nzCustomContent
                    *ngFor="let qa of earningPreviewQuarters"
                    [nzLabel]="qa.name"
                    [nzValue]="qa"
                  >
                    <span class="opt-style" [innerHtml]="qa.name"></span>
                  </nz-option>
                </nz-select>
                <nz-select
                  class="year"
                  id="second-period-year"
                  nzSize="small"
                  [(ngModel)]="secondPeriodYear"
                  (ngModelChange)="estimatedPeriodChange($event, '2')"
                  style="width: auto"
                >
                  <nz-option
                    nzCustomContent
                    *ngFor="let period of periodDropdown"
                    [nzLabel]="period"
                    [nzValue]="period"
                  >
                    <span class="opt-style" [innerHtml]="period"></span>
                  </nz-option>
                </nz-select>
                <span *ngIf="makeCopy"
                  >{{ secondPeriodQA.value }}-{{ secondPeriodYear }}</span
                >
              </div>
            </td>
          </tr>
          <tr class="earnings-table-inner-header">
            <td class="keyValues">
              <span class="key-values-text"
                >Key values ({{ earningsPreviewLen }})</span
              ><span
                nz-popover
                [nzPopoverContent]="contentTemplate"
                nzPopoverTrigger="hover"
                nzPopoverPlacement="right"
                class="key-values-info"
                ><va-icon
                  size="small"
                  name="info-circle"
                  class="fa-sm key-values-info"
                ></va-icon
              ></span>
            </td>
            <ng-template #contentTemplate>
              <div class="popover-info-content">
                The below line items can be edited using the Customize Line Item
                function seen on the Company page
              </div>
            </ng-template>
            <td class="forecastValues">
              <span
                [textContent]="brokerShortName"
                class="headerWrap"
                [title]="brokerShortName"
              ></span>
            </td>
            <td class="consensusValues">Consensus</td>
            <td class="diffValues">
              <nz-select
                id="first-diff"
                nzSize="small"
                nzDropdownClassName="diff-dropdown"
                [(ngModel)]="diff1"
                (ngModelChange)="estimateDiffChange($event, '1', diff1)"
              >
                <nz-option nzCustomContent nzLabel="Diff (#)" nzValue="diff#">
                  <span class="opt-style">Diff (#)</span>
                </nz-option>
                <nz-option nzCustomContent nzLabel="Diff (%)" nzValue="diff%">
                  <span class="opt-style">Diff (%)</span>
                </nz-option>
              </nz-select>
              <span *ngIf="makeCopy">{{ firstDiff }}</span>
            </td>
            <td class="forecastValues">
              <span
                [textContent]="brokerShortName"
                class="headerWrap"
                [title]="brokerShortName"
              ></span>
            </td>
            <td class="consensusValues">Consensus</td>
            <td class="diffValues2">
              <nz-select
                id="second-diff"
                nzSize="small"
                nzDropdownClassName="diff-dropdown"
                [(ngModel)]="diff2"
                (ngModelChange)="estimateDiffChange($event, '2', diff2)"
              >
                <nz-option nzCustomContent nzLabel="Diff (#)" nzValue="diff#">
                  <span class="opt-style">Diff (#)</span>
                </nz-option>
                <nz-option nzCustomContent nzLabel="Diff (%)" nzValue="diff%">
                  <span class="opt-style">Diff (%)</span>
                </nz-option>
              </nz-select>
              <span *ngIf="makeCopy">{{ secondDiff }}</span>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr class="data-row" *ngFor="let rowData of meta">
            <td [textContent]="rowData.header" class="keyValues"></td>
            <td
              class="forecastValues"
              *ngIf="
                !firstPeriodForcast[rowData.dpid].class &&
                !firstPeriodForcast[rowData.dpid].isNA
              "
            >
              <span *ngIf="rowData.setPercent == false">{{
                firstPeriodForcast[rowData.dpid].value
              }}</span>
              <span *ngIf="rowData.setPercent == true"
                >{{ firstPeriodForcast[rowData.dpid].value }}%</span
              >
            </td>
            <td
              class="forecastValues make-me-red"
              *ngIf="
                firstPeriodForcast[rowData.dpid].class &&
                !firstPeriodForcast[rowData.dpid].isNA
              "
            >
              <span *ngIf="rowData.setPercent == false"
                >({{ firstPeriodForcast[rowData.dpid].value }})</span
              >
              <span *ngIf="rowData.setPercent == true"
                >({{ firstPeriodForcast[rowData.dpid].value }}%)</span
              >
            </td>
            <td
              class="forecastValues"
              *ngIf="firstPeriodForcast[rowData.dpid].isNA"
            >
              <span>{{ firstPeriodForcast[rowData.dpid].value }}</span>
            </td>

            <td
              class="consensusValues"
              *ngIf="
                !firstPeriodConsensus[rowData.dpid].class &&
                !firstPeriodConsensus[rowData.dpid].isNA
              "
            >
              <span *ngIf="rowData.setPercent == false">{{
                firstPeriodConsensus[rowData.dpid].value
              }}</span>
              <span *ngIf="rowData.setPercent == true"
                >{{ firstPeriodConsensus[rowData.dpid].value }}%</span
              >
            </td>
            <td
              class="consensusValues make-me-red"
              *ngIf="
                firstPeriodConsensus[rowData.dpid].class &&
                !firstPeriodConsensus[rowData.dpid].isNA
              "
            >
              <span *ngIf="rowData.setPercent == false"
                >({{ firstPeriodConsensus[rowData.dpid].value }})</span
              >
              <span *ngIf="rowData.setPercent == true"
                >({{ firstPeriodConsensus[rowData.dpid].value }}%)</span
              >
            </td>
            <td
              class="consensusValues"
              *ngIf="firstPeriodConsensus[rowData.dpid].isNA"
            >
              <span>{{ firstPeriodConsensus[rowData.dpid].value }}</span>
            </td>

            <td
              class="diffValues make-me-green"
              *ngIf="
                !firstPeriodDiff[rowData.dpid].class &&
                !firstPeriodDiff[rowData.dpid].isNA &&
                firstPeriodDiff[rowData.dpid].value != 0
              "
            >
              <span *ngIf="rowData.setPercent === false && diff1 !== 'diff%'">{{
                firstPeriodDiff[rowData.dpid].value
              }}</span>
              <span *ngIf="rowData.setPercent === true && diff1 !== 'diff%'"
                >{{ firstPeriodDiff[rowData.dpid].value }}%</span
              >
              <span *ngIf="diff1 === 'diff%'"
                >{{ firstPeriodDiff[rowData.dpid].value
                }}{{ rowData.unitSymbol }}</span
              >
            </td>
            <td
              class="diffValues"
              *ngIf="
                !firstPeriodDiff[rowData.dpid].class &&
                !firstPeriodDiff[rowData.dpid].isNA &&
                firstPeriodDiff[rowData.dpid].value == 0
              "
            >
              <span *ngIf="rowData.setPercent == false && diff1 != 'diff%'">{{
                firstPeriodDiff[rowData.dpid].value
              }}</span>
              <span *ngIf="rowData.setPercent == true && diff1 != 'diff%'"
                >{{ firstPeriodDiff[rowData.dpid].value }}%</span
              >
              <span *ngIf="diff1 == 'diff%'"
                >{{ firstPeriodDiff[rowData.dpid].value
                }}{{ rowData.unitSymbol }}</span
              >
            </td>
            <td
              class="diffValues make-me-red"
              *ngIf="
                firstPeriodDiff[rowData.dpid].class &&
                !firstPeriodDiff[rowData.dpid].isNA
              "
            >
              <span *ngIf="rowData.setPercent == false && diff1 != 'diff%'"
                >({{ firstPeriodDiff[rowData.dpid].value }})</span
              >
              <span *ngIf="rowData.setPercent == true && diff1 != 'diff%'"
                >({{ firstPeriodDiff[rowData.dpid].value }}%)</span
              >
              <span *ngIf="diff1 == 'diff%'"
                >({{ firstPeriodDiff[rowData.dpid].value
                }}{{ rowData.unitSymbol }})</span
              >
            </td>
            <td class="diffValues" *ngIf="firstPeriodDiff[rowData.dpid].isNA">
              <span>{{ firstPeriodDiff[rowData.dpid].value }}</span>
            </td>

            <td
              class="forecastValues"
              *ngIf="
                !secondPeriodForcast[rowData.dpid].class &&
                !secondPeriodForcast[rowData.dpid].isNA
              "
            >
              <span *ngIf="rowData.setPercent == false">{{
                secondPeriodForcast[rowData.dpid].value
              }}</span>
              <span *ngIf="rowData.setPercent == true"
                >{{ secondPeriodForcast[rowData.dpid].value }}%</span
              >
            </td>
            <td
              class="forecastValues make-me-red"
              *ngIf="
                secondPeriodForcast[rowData.dpid].class &&
                !secondPeriodForcast[rowData.dpid].isNA
              "
            >
              <span *ngIf="rowData.setPercent == false"
                >({{ secondPeriodForcast[rowData.dpid].value }})</span
              >
              <span *ngIf="rowData.setPercent == true"
                >({{ secondPeriodForcast[rowData.dpid].value }}%)</span
              >
            </td>
            <td
              class="forecastValues"
              *ngIf="secondPeriodForcast[rowData.dpid].isNA"
            >
              <span>{{ secondPeriodForcast[rowData.dpid].value }}</span>
            </td>

            <td
              class="consensusValues"
              *ngIf="
                !secondPeriodConsensus[rowData.dpid].class &&
                !secondPeriodConsensus[rowData.dpid].isNA
              "
            >
              <span *ngIf="rowData.setPercent == false">{{
                secondPeriodConsensus[rowData.dpid].value
              }}</span>
              <span *ngIf="rowData.setPercent == true"
                >{{ secondPeriodConsensus[rowData.dpid].value }}%</span
              >
            </td>
            <td
              class="consensusValues make-me-red"
              *ngIf="
                secondPeriodConsensus[rowData.dpid].class &&
                !secondPeriodConsensus[rowData.dpid].isNA
              "
            >
              <span *ngIf="rowData.setPercent == false"
                >({{ secondPeriodConsensus[rowData.dpid].value }})</span
              >
              <span *ngIf="rowData.setPercent == true"
                >({{ secondPeriodConsensus[rowData.dpid].value }}%)</span
              >
            </td>
            <td
              class="consensusValues"
              *ngIf="secondPeriodConsensus[rowData.dpid].isNA"
            >
              <span>{{ secondPeriodConsensus[rowData.dpid].value }}</span>
            </td>

            <td
              class="diffValues2 make-me-green"
              *ngIf="
                !secondPeriodDiff[rowData.dpid].class &&
                !secondPeriodDiff[rowData.dpid].isNA &&
                secondPeriodDiff[rowData.dpid].value != 0
              "
            >
              <span *ngIf="rowData.setPercent == false && diff2 != 'diff%'">{{
                secondPeriodDiff[rowData.dpid].value
              }}</span>
              <span *ngIf="rowData.setPercent == true && diff2 != 'diff%'"
                >{{ secondPeriodDiff[rowData.dpid].value }}%</span
              >
              <span *ngIf="diff2 == 'diff%'"
                >{{ secondPeriodDiff[rowData.dpid].value
                }}{{ rowData.unitSymbol }}</span
              >
            </td>
            <td
              class="diffValues2"
              *ngIf="
                !secondPeriodDiff[rowData.dpid].class &&
                !secondPeriodDiff[rowData.dpid].isNA &&
                secondPeriodDiff[rowData.dpid].value == 0
              "
            >
              <span *ngIf="rowData.setPercent == false && diff2 != 'diff%'">{{
                secondPeriodDiff[rowData.dpid].value
              }}</span>
              <span *ngIf="rowData.setPercent == true && diff2 != 'diff%'"
                >{{ secondPeriodDiff[rowData.dpid].value }}%</span
              >
              <span *ngIf="diff2 == 'diff%'"
                >{{ secondPeriodDiff[rowData.dpid].value
                }}{{ rowData.unitSymbol }}</span
              >
            </td>
            <td
              class="diffValues2 make-me-red"
              *ngIf="
                secondPeriodDiff[rowData.dpid].class &&
                !secondPeriodDiff[rowData.dpid].isNA
              "
            >
              <span *ngIf="rowData.setPercent == false && diff2 != 'diff%'"
                >({{ secondPeriodDiff[rowData.dpid].value }})</span
              >
              <span *ngIf="rowData.setPercent == true && diff2 != 'diff%'"
                >({{ secondPeriodDiff[rowData.dpid].value }}%)</span
              >
              <span *ngIf="diff2 == 'diff%'"
                >({{ secondPeriodDiff[rowData.dpid].value
                }}{{ rowData.unitSymbol }})</span
              >
            </td>
            <td class="diffValues2" *ngIf="secondPeriodDiff[rowData.dpid].isNA">
              <span>{{ secondPeriodDiff[rowData.dpid].value }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
